import { makeStyles } from '@mui/styles'

const useAutocompleteDropdownStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& .MuiAutocomplete-root': {
      width: '100%',
    },
  },
}))

export default useAutocompleteDropdownStyles
